// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6fca635","879":"bd375427"}[chunkId] + ".chunk.js";
};